<!-- A háttérre kattintás NEM zár be: csak az X / Mégse, megerősítéssel. -->
<div class="eu-overlay">
  <div class="eu-modal" (click)="stop($event)">
    <div class="eu-title-row">
      <div class="eu-title">{{ title }}</div>
      <button type="button" class="eu-close-btn" title="Bezárás" (click)="cancel()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
      </button>
    </div>

    <div class="eu-body">

      <div class="eu-profile"
           [class.eu-profile--drag]="dragActive"
           (dragover)="onDragOver($event)"
           (dragleave)="onDragLeave($event)"
           (drop)="onDrop($event)">
        <div class="eu-profile__avatar"
             [style.background]="(previewUrl || existingImage) ? null : (initials ? avatarColor : null)"
             (click)="triggerFilePick()"
             title="Kép feltöltése">
          <img *ngIf="previewUrl" class="eu-profile__img" [src]="previewUrl" alt="Profilkép">
          <img *ngIf="!previewUrl && existingImage" class="eu-profile__img" [appFetchUserImage]="existingImage" alt="Profilkép">
          <ng-container *ngIf="!previewUrl && !existingImage">
            <span *ngIf="initials; else avatarPlaceholder">{{ initials }}</span>
            <ng-template #avatarPlaceholder><span class="eu-profile__placeholder">Kép</span></ng-template>
          </ng-container>
        </div>
        <div class="eu-profile__copy">
          <div class="eu-field-label">Profilkép</div>
          <div class="eu-profile__hint">Húzz ide egy képet vagy kattints a feltöltéshez.</div>
          <button *ngIf="previewUrl" type="button" class="eu-profile__remove" (click)="clearSelectedImage()">Kiválasztott kép elvetése</button>
        </div>
        <input #fileInput type="file" accept="image/*" hidden (change)="onFileSelected($event)">
      </div>

      <div>
        <div class="eu-field-label">Felhasználónév</div>
        <input type="text" class="eu-input eu-input--name" [(ngModel)]="username">
      </div>

      <div>
        <div class="eu-field-label">Név</div>
        <input type="text" class="eu-input eu-input--name" [(ngModel)]="fullName">
      </div>

      <div>
        <div class="eu-field-label">E-mail</div>
        <input type="text" class="eu-input" [(ngModel)]="email">
      </div>

      <div>
        <div class="eu-field-label eu-field-label--chips">Szerepkör</div>
        <div class="eu-role-chips">
          <button
            type="button"
            class="eu-role-chip"
            *ngFor="let r of roles"
            [class.eu-role-chip--active]="isRoleSelected(r)"
            [style.borderColor]="isRoleSelected(r) ? (roleChipColor(r) || 'var(--stk-accent)') : null"
            [style.color]="isRoleSelected(r) ? (roleChipColor(r) || '#4C7A2E') : null"
            (click)="toggleRole(r)">
            {{ roleLabel(r) }}
          </button>
        </div>
      </div>

      <div>
        <div class="eu-field-label eu-field-label--chips">Foglalkoztatás</div>
        <div class="eu-state-chips">
          <button
            type="button"
            class="eu-state-chip"
            *ngFor="let e of employmentChips"
            [class.eu-state-chip--active]="employmentType === e.value"
            (click)="setEmploymentType(e.value)">
            {{ e.label }}
          </button>
        </div>
        <div class="eu-employment-hint">{{ employmentHint }}</div>
      </div>

      <div>
        <div class="eu-field-label eu-field-label--chips">Állapot</div>
        <div class="eu-state-chips">
          <button type="button" class="eu-state-chip" [class.eu-state-chip--active]="active" (click)="active = true">Aktív</button>
          <button type="button" class="eu-state-chip" [class.eu-state-chip--active]="!active" (click)="active = false">Inaktív</button>
        </div>
      </div>

      <div>
        <div class="eu-field-label eu-field-label--chips">Csapatchat</div>
        <button type="button" class="eu-chat" [class.eu-chat--on]="chatMember" (click)="toggleChat()" role="switch" [attr.aria-checked]="chatMember">
          <span class="eu-chat__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5.5 h16 a1.5 1.5 0 0 1 1.5 1.5 v9 a1.5 1.5 0 0 1 -1.5 1.5 H10 l-4.5 3.5 V17.5 H4 A1.5 1.5 0 0 1 2.5 16 V7 A1.5 1.5 0 0 1 4 5.5 Z"></path></svg>
          </span>
          <span class="eu-chat__text">
            <b>{{ chatMember ? 'Tagja a csapatchatnek' : 'Nem tagja a csapatchatnek' }}</b>
            <span>{{ chatMember ? 'Látja a Fő chatet, lehet neki privátban írni, és értesítést kap az üzenetekről.' : 'Nem látja a chatet, és a csapatlistában sem szerepel.' }}</span>
          </span>
          <span class="eu-chat__switch"><i></i></span>
        </button>
      </div>

      <div>
        <div class="eu-field-label eu-field-label--chips">Foxi oldal</div>
        <button type="button" class="eu-chat" [class.eu-chat--on]="foxiAccess" (click)="toggleFoxi()" role="switch" [attr.aria-checked]="foxiAccess">
          <span class="eu-chat__icon">
            <img src="assets/foxi.png" alt="" width="26" height="26" style="border-radius:50%">
          </span>
          <span class="eu-chat__text">
            <b>{{ foxiAccess ? 'Látja a Foxi oldalt' : 'Nem látja a Foxi oldalt' }}</b>
            <span>{{ foxiAccess ? 'Kezelheti Foxi időzített feladatait és emlékeit, látja a költést.' : 'Foxival a chatben ettől még beszélgethet.' }}</span>
          </span>
          <span class="eu-chat__switch"><i></i></span>
        </button>
      </div>

      <div>
        <div class="eu-field-label eu-field-label--chips">Boris oldal</div>
        <button type="button" class="eu-chat" [class.eu-chat--on]="borisAccess" (click)="toggleBoris()" role="switch" [attr.aria-checked]="borisAccess">
          <span class="eu-chat__icon">
            <img src="assets/boris.png" alt="" width="26" height="26" style="border-radius:50%">
          </span>
          <span class="eu-chat__text">
            <b>{{ borisAccess ? 'Látja a Boris oldalt' : 'Nem látja a Boris oldalt' }}</b>
            <span>{{ borisAccess ? 'Szerkesztheti Boris tudástárát, látja a tervezőgép állapotát.' : 'Borisszal a chatben ettől még beszélgethet.' }}</span>
          </span>
          <span class="eu-chat__switch"><i></i></span>
        </button>
      </div>

      <div>
        <div class="eu-field-label eu-field-label--chips">Farmy oldal</div>
        <button type="button" class="eu-chat" [class.eu-chat--on]="farmyAccess" (click)="toggleFarmy()" role="switch" [attr.aria-checked]="farmyAccess">
          <span class="eu-chat__icon">
            <img src="assets/farmy.png" alt="" width="26" height="26" style="border-radius:50%">
          </span>
          <span class="eu-chat__text">
            <b>{{ farmyAccess ? 'Látja a Farmy oldalt' : 'Nem látja a Farmy oldalt' }}</b>
            <span>{{ farmyAccess ? 'Szerkesztheti Farmy tudástárát, látja a mini PC állapotát.' : 'Farmyval a chatben ettől még beszélgethet.' }}</span>
          </span>
          <span class="eu-chat__switch"><i></i></span>
        </button>
      </div>

      <div>
        <div class="eu-menu-head">
          <div class="eu-field-label eu-field-label--inline">Jogosultságok — látható menüpontok</div>
          <span class="eu-menu-count">{{ menuCountLabel }}</span>
        </div>
        <div class="eu-menu-grid">
          <div
            class="eu-menu-row"
            *ngFor="let m of navMenus"
            [class.eu-menu-row--on]="isMenuOn(m)"
            (click)="toggleMenu(m)">
            <span class="eu-menu-box" [class.eu-menu-box--on]="isMenuOn(m)">
              <svg *ngIf="isMenuOn(m)" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="5,12.5 10,17.5 19,7.5"></polyline></svg>
            </span>
            <span class="eu-menu-label" [class.eu-menu-label--on]="isMenuOn(m)">{{ m }}</span>
          </div>
        </div>
        <div class="eu-etsy" *ngIf="etsyMenuOn">
          <div class="eu-menu-head">
            <div class="eu-field-label eu-field-label--inline">Etsy shopok — melyiket lássa</div>
            <span class="eu-menu-count">{{ etsyShopSummary }}</span>
          </div>
          <input class="eu-input" placeholder="Szűrés az Etsy shop nevére…" [(ngModel)]="etsyShopQuery">
          <div class="eu-menu-grid">
            <div
              class="eu-menu-row"
              *ngFor="let s of filteredEtsyShops"
              [class.eu-menu-row--on]="isEtsyShopOn(s.id)"
              (click)="toggleEtsyShop(s.id)">
              <span class="eu-menu-box" [class.eu-menu-box--on]="isEtsyShopOn(s.id)">
                <svg *ngIf="isEtsyShopOn(s.id)" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="5,12.5 10,17.5 19,7.5"></polyline></svg>
              </span>
              <span class="eu-menu-label" [class.eu-menu-label--on]="isEtsyShopOn(s.id)">{{ s.name }}</span>
            </div>
          </div>
          <div class="eu-menu-note" *ngIf="!filteredEtsyShops.length">Nincs ilyen nevű shop.</div>
        </div>
        <div class="eu-menu-note">A rejtett oldal az URL beírásával sem nyílik meg. A <strong>Beállítások</strong> (API-kulcsok, jelszavak, postafiók) alapból csak adminnak látszik — másnak itt adhatsz jogot. A <strong>Levelezés</strong> a Support része: Support nélkül nem érhető el.</div>
      </div>

      <div>
        <div class="eu-field-label eu-field-label--chips">{{ pwHeading }}</div>

        <div class="eu-pw-set" *ngIf="!pwEditing">
          <div class="eu-pw-set__info">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#8A9464" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10.5" width="16" height="10" rx="2"></rect><path d="M8 10.5 V7.5 a4 4 0 0 1 8 0 v3"></path></svg>
            <span>Jelszó beállítva</span>
          </div>
          <button type="button" class="eu-pw-change-btn" (click)="startPwChange()">Jelszó módosítása</button>
        </div>

        <ng-container *ngIf="pwEditing">
          <div class="eu-pw-edit">
            <div class="eu-pw-input-wrap">
              <input
                class="eu-input eu-input--pw"
                [type]="pwVisible ? 'text' : 'password'"
                placeholder="Legalább 8 karakter"
                [(ngModel)]="password">
              <button type="button" class="eu-pw-eye" title="Megjelenítés / elrejtés" (click)="togglePwVisibility()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12 s3.5 -6.5 10 -6.5 S22 12 22 12 s-3.5 6.5 -10 6.5 S2 12 2 12 Z"></path><circle cx="12" cy="12" r="2.6"></circle></svg>
              </button>
            </div>
            <button type="button" class="eu-pw-generate" (click)="generatePassword()">Generálás</button>
          </div>
          <div class="eu-pw-hint" [style.color]="pwHintColor">{{ pwHint }}</div>
        </ng-container>
      </div>

    </div>

    <div class="eu-actions">
      <button type="button" class="eu-cancel-btn" (click)="cancel()">Mégse</button>
      <button
        type="button"
        class="eu-save-btn"
        [class.eu-save-btn--disabled]="!canSave || isSaving"
        (click)="save()">
        Mentés
      </button>
    </div>
  </div>
</div>
